import { Chip, Grid, Paper, useTheme } from "@mui/material";
import { IUser } from "@vmosolutions/oc-interfaces";
import HelpIcon from "@mui/icons-material/Help";

interface IUserCardProps {
  user: IUser;
}

export const UserCard = (props: IUserCardProps): JSX.Element => {
  const { user } = props;
  const theme = useTheme();
  const headerSX = {
    fontSize: "0.7em",
    color: theme.palette.grey[400],
    textTransform: "uppercase",
  };
  return (
    <Paper elevation={4} sx={{ p: 1 }}>
      <Grid container>
        <Grid container item xs={12} md={2}>
          <Grid item xs={12} sx={headerSX}>
            Preferred Name
          </Grid>
          <Grid item xs={12}>
            {user.preferredName ? user.preferredName : user.firstName}
          </Grid>
        </Grid>
        <Grid container item xs={12} md={3}>
          <Grid item xs={12} sx={headerSX}>
            Name
          </Grid>
          <Grid item xs={12}>
            {`${user.firstName} ${user.middleName ?? ""} ${user.lastName}`}
          </Grid>
        </Grid>
        <Grid container item xs={12} md={2}>
          <Grid item xs={12} sx={headerSX}>
            Status
          </Grid>
          <Grid item xs={12}>
            <Chip
              variant="filled"
              size="small"
              sx={{ borderRadius: 0 }}
              color={user.active ? "success" : "error"}
              label={user.active ? "Active" : "Inactive"}
            />
          </Grid>
        </Grid>
        <Grid container item xs={12} md={3}>
          <Grid item xs={12} sx={headerSX}>
            Email
          </Grid>
          <Grid item xs={12}>
            {user.email}
          </Grid>
        </Grid>
        <Grid container item xs={12} md={2}>
          <Grid item xs={12} sx={headerSX}>
            Employee ID
          </Grid>
          <Grid item xs={12}>
            {user?.employeeId ? `(${user.employeeId})` : ""}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            pt: 1,
            display: "flex",
            alignItems: "center",
            fontSize: "0.8em",
            color: theme.palette.grey[400],
          }}
        >
          <HelpIcon fontSize="small" sx={{ mr: 1, fontSize: "1.6em" }} /> This information is transferred from the crew
          member's user record, managed in the User admin tab
        </Grid>
      </Grid>
    </Paper>
  );
};
